import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'descripcion',
    label: i18n('entities.clasificacionTercero.fields.descripcion'),
    schema: schemas.string(
      i18n('entities.clasificacionTercero.fields.descripcion'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'habilitado',
    label: i18n('entities.clasificacionTercero.fields.habilitado'),
    schema: schemas.boolean(
      i18n('entities.clasificacionTercero.fields.habilitado'),
      {},
    ),
  },
  {
    name: 'tercerosVinculados',
    label: i18n('entities.clasificacionTercero.fields.tercerosVinculados'),
    schema: schemas.relationToMany(
      i18n('entities.clasificacionTercero.fields.tercerosVinculados'),
      {},
    ),
  },
];